import { NumberPatternType } from '@dreryk/react-common';
import { InteractiveTable, InteractiveTableCellProps, useInteractiveTableContext } from '@dreryk/react-components';

import { InvoiceItemsTableBean } from './InvoiceItemsTable.types';
import { medicalServiceRowVisitor, NEW_ROW_EMPTY_VALUE_PLACEHOLDER } from './InvoiceItemsTable.utils';

const MAX_QUANTITY = 999;
const MIN_QUANTITY = 1;
const STEP_VALUE = 1;

type InvoiceItemsTableQuantityCellProps = InteractiveTableCellProps<number>;

export const InvoiceItemsTableQuantityCell = (props: InvoiceItemsTableQuantityCellProps): JSX.Element => {
   const { defaultValue, index, name, testId } = props;
   const { getCellValue } = useInteractiveTableContext<InvoiceItemsTableBean>();
   const invoiceParameters = getCellValue('invoiceParameters', index);
   const quantity = getCellValue('quantity', index);

   return medicalServiceRowVisitor({
      nameEditable: invoiceParameters.nameEditable,
      rowAddedManually: invoiceParameters.rowAddedManually,
   })({
      visitFetchedRow: () => (
         <InteractiveTable.NumberInputCell
            defaultValue={defaultValue}
            enableControlButtons
            index={index}
            max={MAX_QUANTITY}
            min={MIN_QUANTITY}
            name={name}
            pattern={NumberPatternType.POSITIVE_INTEGER}
            stepValue={STEP_VALUE}
            testId={testId}
            validationRules={{
               required: true,
            }}
         />
      ),
      visitManuallyAddedRow: () => (
         <InteractiveTable.CustomCell defaultValue={defaultValue} index={index} name={name} testId={testId}>
            {() => <>{NEW_ROW_EMPTY_VALUE_PLACEHOLDER}</>}
         </InteractiveTable.CustomCell>
      ),
      visitManuallyAddedRowWithName: () => (
         <InteractiveTable.NumberInputCell
            compact
            defaultValue={quantity}
            enableControlButtons
            index={index}
            max={MAX_QUANTITY}
            min={MIN_QUANTITY}
            name={name}
            pattern={NumberPatternType.POSITIVE_INTEGER}
            stepValue={STEP_VALUE}
            testId={testId}
            validationRules={{
               required: true,
            }}
         />
      ),
   });
};
